import React, { useEffect, useState } from 'react';
import styles from '../styles/ScrollControls.module.css';

const SCROLL_STEP_RATIO = 0.88;

const ScrollControls = () => {
    const [canScrollUp, setCanScrollUp] = useState(false);
    const [canScrollDown, setCanScrollDown] = useState(false);

    useEffect(() => {
        const updateState = () => {
            const scrollTop = window.scrollY || document.documentElement.scrollTop || 0;
            const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
            const pageHeight = Math.max(
                document.body.scrollHeight,
                document.documentElement.scrollHeight
            );

            setCanScrollUp(scrollTop > 140);
            setCanScrollDown(scrollTop + viewportHeight < pageHeight - 140);
        };

        updateState();
        window.addEventListener('scroll', updateState, { passive: true });
        window.addEventListener('resize', updateState);

        return () => {
            window.removeEventListener('scroll', updateState);
            window.removeEventListener('resize', updateState);
        };
    }, []);

    const scrollPage = (direction) => {
        const step = Math.max(360, Math.round(window.innerHeight * SCROLL_STEP_RATIO));
        window.scrollBy({
            top: direction * step,
            left: 0,
            behavior: 'smooth'
        });
    };

    const scrollToTop = () => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    };

    if (!canScrollUp && !canScrollDown) {
        return null;
    }

    return (
        <div className={styles.controls} aria-label="Controles de desplazamiento rapido">
            <button
                type="button"
                className={styles.button}
                aria-label="Subir al principio"
                disabled={!canScrollUp}
                onClick={scrollToTop}
            >
                <span className={styles.chevronUp} aria-hidden="true" />
            </button>
            <button
                type="button"
                className={styles.button}
                aria-label="Bajar rapido"
                disabled={!canScrollDown}
                onClick={() => scrollPage(1)}
            >
                <span className={styles.chevronDown} aria-hidden="true" />
            </button>
        </div>
    );
};

export default ScrollControls;
